import React from 'react';
import { Modal } from 'Components/Modal';
import './UpdatePaymentModal.css';
import { PaymentForm } from 'Forms/PaymentForm';

export const UpdatePaymentModal = ({ isShowing, onPaymentSubmit, onClose }) => {
  return (
    <Modal isShowing={isShowing} onClose={onClose} customClass="applyCouponPaymentModal">
      <div className="applyCouponPaymentForm">
        <div className="paymentText">
          <div className="title">Update your payment information</div>
          <div className="description">Please update your card to apply coupon.</div>
          <div className="divider" />
        </div>
        <PaymentForm
          showSecureCheckoutLabel={false}
          onFormSubmit={onPaymentSubmit}
          onCancelClick={onClose}
          submitButtonText="Apply"
          showCancelButton
        />
      </div>
    </Modal>
  );
};
